import { render, staticRenderFns } from "./TopicSelection.vue?vue&type=template&id=754f1eb0&scoped=true"
import script from "./TopicSelection.vue?vue&type=script&lang=js"
export * from "./TopicSelection.vue?vue&type=script&lang=js"
import style0 from "./TopicSelection.vue?vue&type=style&index=0&id=754f1eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754f1eb0",
  null
  
)

export default component.exports